import { createAction } from 'redux-actions';

export const copyToClipboard = createAction('COPY_TO_CLIPBOARD');
export const clearClipboard = createAction('CLEAR_CLIPBOARD');
export const clearClipboardKey = createAction('CLEAR_CLIPBOARD_KEY');
export const deleteClipboardItem = createAction('DELETE_CLIPBOARD_ITEM');
